angular
  .module('fca-used')
  .component('vehicleDetails', {
    bindings: {
      data: '<',
      dealer: '<',
      phone: '<',
      installments: '<'
    },
    templateUrl: 'app/vehicle/vehicle-details.html',
    controller: vehicleDetailsController,
    controllerAs: 'vehicle'
  });

vehicleDetailsController.$inject = ['$sce', '$http', '$window', '$translate', 'wishlist', 'tagging', 'uvl', 'InstallmentsCalculator', 'CONFIG'];
function vehicleDetailsController($sce, $http, $window, $translate, wishlist, tagging, uvl, InstallmentsCalculator, CONFIG) {
  var self = this;

  self.config = CONFIG;
  self.optionals = [];

  self.toggleWishlist = function () {
    if (self.data.inWishlist) {
      wishlist.remove(self.data.vin);
      self.data.inWishlist = false;
    } else {
      wishlist.add(self.data);
      self.data.inWishlist = true;
    }
  };

  self.loadImpressum = function () {
    uvl.getImpressum(self.dealer.LEGAL_ENTITY)
      .then(function (impressumHTML) {
        if (impressumHTML) {
          self.impressumHTML = impressumHTML;
          self.showImpressum = true;
        }
      });
  };

  self.getShareLink = function () {
    return $window.location.href;
  };

  self.share = function (target) {
    self.shareLink = $window.location.href;
    var text;
    switch (target) {
      case 'facebook':
        // $window.location.href = uvl.getShareUrl('FB', self.data);
        // text = $translate.instant('vehicle_share_template_facebook', {link: self.shareLink});
        $window.open('https://www.facebook.com/sharer/sharer.php?u=' + $window.encodeURIComponent(self.shareLink), '_blank');
        break;
      case 'twitter':
        text = $translate.instant('vehicle_share_template_twitter', {link: self.shareLink});
        $window.open('https://twitter.com/intent/tweet?text=' + $window.encodeURIComponent(text), '_blank');
        break;
      case 'whatsapp':
        text = $translate.instant('vehicle_share_template_whatsapp', {link: self.shareLink});
        $window.location.href = 'whatsapp://send?text=' + $window.encodeURIComponent(text);
        break;
      case 'email':
        var flagMobile = (uvl.getConsumer() === 'MOBILE');
        text = $translate.instant('vehicle_share_template_email', {link: self.shareLink});
        if (flagMobile) {
          $window.location.href = 'mailto:' + text;
        } else {
          $window.open('mailto:' + text, '_blank');
        }
        break;
      default: break;
    }
  };

  self.$onInit = function () {
    wishlist.close();
    self.kw = Math.round(self.data.horsePower * 0.73549875);
    if (CONFIG.mirafioriStripe && CONFIG.mirafioriStripe.selector) {
      var target = $window.document.querySelector(CONFIG.mirafioriStripe.selector);
      if (target) {
        target.style.display = 'none';
      }
    }

    self.data.dealer = Object.keys(self.dealer).length === 0 ? false : self.dealer;

    self.warranty = self.config.search.premium.warrantyCode;
    self.data.inWishlist = Boolean(wishlist.get(self.data.vin));

    if (self.data.standardOptionals) {
      self.optionals = self.optionals.concat(self.data.standardOptionals);
    }

    if (!(CONFIG.mynumber && CONFIG.mynumber.enabled && !CONFIG.mynumber.enableDealerLocatorFallback) &&
        !self.phone && self.dealer.TEL_1 && self.dealer.TEL_1 !== ' ') {
      self.phone = {
        number: self.dealer.TEL_1,
        parsed: self.dealer.TEL_1.match(/\d/g).join('')
      };
    }

    self.scrollToContactForm = function () {
      $window.document.querySelector('.contact-form-wrapper')
        .scrollIntoView({
          behavior: 'smooth'
        });
    };

    if (self.data.payedOptionals) {
      self.optionals = self.optionals.concat(self.data.payedOptionals);
    }

    if (self.data.standardOptional &&
        CONFIG.vehicleDetailFields &&
        CONFIG.vehicleDetailFields.dealerNotes &&
        CONFIG.vehicleDetailFields.dealerNotes.parse &&
        CONFIG.vehicleDetailFields.dealerNotes.separator) {
      self.parsedOptionals = self.data.standardOptional.split(CONFIG.vehicleDetailFields.dealerNotes.separator);
    }

    if (self.data.optionalForFee &&
        CONFIG.vehicleDetailFields &&
        CONFIG.vehicleDetailFields.dealerNotes &&
        CONFIG.vehicleDetailFields.dealerNotes.parse &&
        CONFIG.vehicleDetailFields.dealerNotes.separator) {
      self.parsedOptionalsForFee = self.data.optionalForFee.split(CONFIG.vehicleDetailFields.dealerNotes.separator);
    }

    self.price = {
      price: self.data.priceCurrent,
      unit: CONFIG.search.price.unit
    };

    self.registration = {
      date: new Date(self.data.registrationYear, self.data.registrationMonth - 1, self.data.registrationDay),
      format: $translate.instant('vehicle_date_format')
    };

    if (CONFIG.vehicleDetailFields && String(CONFIG.vehicleDetailFields.enableDealerWebsite)) {
      self.showDealerWEBSITE = CONFIG.vehicleDetailFields.enableDealerWebsite;
    } else {
      self.showDealerWEBSITE = true;
    }
    /*
    $http.get(CONFIG.contactForm.url)
      .then(function (response) {
        $window.document.querySelector('.contact-form-wrapper').innerHTML = response.data;
      });
    */
    if (self.data.dealer.YCOORD && self.data.dealer.XCOORD) {
      self.mapLink = 'http://share.here.com/l/' + self.data.dealer.YCOORD + ',' + self.data.dealer.XCOORD + ',' + self.data.dealer.COMPANYNAM + '?p=yes&z=10&t=traffic';
      if (angular.isDefined($window.digitalData) && $window.digitalData.page.pageInfo.sysEnv.toLowerCase() !== 'desktop') {
        self.mapLink = 'http://maps.apple.com/?q=' + self.data.dealer.COMPANYNAM + '&ll=' + self.data.dealer.YCOORD + ',' + self.data.dealer.XCOORD + '&sll=' + self.data.dealer.YCOORD + ',' + self.data.dealer.XCOORD;
      }
    } else {
      self.mapLink = null;
    }
    tagging.track({
      page: 'used:offer',
      // vehicleBrand: 'used',
      // businessArea: 'used',
      usedVehicle: self.data
    });
  };

  self.contactFormUrl = $sce.trustAsResourceUrl(CONFIG.contactForm.url);

  self.openInstallmentsModal = function () {
    angular.element(document).find('html').css('position', 'fixed');
    angular.element(document).find('body').css('position', 'fixed');
    self.installmentsModal = {
      show: true,
      url: InstallmentsCalculator.getIframeUrl(self.data)
    };

    $window.addEventListener('message', handleInstallmentsModalEvent);
  };

  self.closeInstallmentsModal = function () {
    angular.element(document).find('html').css('position', 'static');
    angular.element(document).find('body').css('position', 'static');
    delete self.installmentsModal;
  };

  function handleInstallmentsModalEvent(event) {
    if (event.origin === CONFIG.installmentsCalculator.iframe.domain) {
      try {
        if (angular.fromJson(event.data).method === 'refresh') {
          self.closeInstallmentsModal();
          InstallmentsCalculator.getMonthlyRate(self.data)
            .then(function (response) {
              self.installments = response[InstallmentsCalculator.getMVS(self.data)];
            });
        }
      } catch (error) {}
    }
  }
}
